import React, { useState, useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import ActiveTradeGroupsTable from './metrics/ActiveTradeGroupsTable';
import TradeGroupWizard from './TradeGroupWizard';
import DashboardBottomLogo from './DashboardBottomLogo';
import SectionTitle from './shared/SectionTitle';
import { useGlobalAutoRefreshStore, useAutoRefreshTrigger } from '../stores/useGlobalAutoRefreshStore';
import './TradeGroups.css';

const TradeGroups: React.FC = () => {
  const queryClient = useQueryClient();
  const setActiveDashboard = useGlobalAutoRefreshStore((state) => state.setActiveDashboard);
  const refreshTrigger = useAutoRefreshTrigger('trade-groups');
  const [showWizard, setShowWizard] = useState(false);
  const [selectedTypeFilter, setSelectedTypeFilter] = useState<string[]>([]);

  // Set this dashboard as active when mounted, clear when unmounted
  useEffect(() => {
    setActiveDashboard('trade-groups');
    return () => setActiveDashboard(null);
  }, [setActiveDashboard]);

  // When global refresh trigger changes, invalidate all queries to refetch data
  useEffect(() => {
    if (refreshTrigger > 0) {
      queryClient.invalidateQueries();
    }
  }, [refreshTrigger, queryClient]);

  const handleWizardSuccess = (tradeGroupId: string) => {
    console.log('Trade group created:', tradeGroupId);
    setShowWizard(false);
    alert(`Trade group created successfully! ID: ${tradeGroupId}`);
  };

  return (
    <div className="trade-groups">
      <div className="dashboard-header">
        <SectionTitle
          title="Trade Group Management"
        />
        <button className="primary-button" onClick={() => setShowWizard(true)}>
          + Create New Trade Group
        </button>
      </div>

      {/* Strategy filtering now lives in the Active Trade Groups table's
          "Strategy Type" filter (a multi-select modal of described cards), so
          the table is the first thing visible on landing — no card strip. */}

      {/* Active Trade Groups Table */}
      <div className="active-trade-groups-section">
        <ActiveTradeGroupsTable
          selectedTypeFilter={selectedTypeFilter}
          onTypeFilterChange={setSelectedTypeFilter}
        />
      </div>

      {/* Trade Group Creation Wizard Modal */}
      {showWizard && (
        <TradeGroupWizard
          onClose={() => setShowWizard(false)}
          onSuccess={handleWizardSuccess}
        />
      )}

      <DashboardBottomLogo />
    </div>
  );
};

export default TradeGroups;
